import { get as ldGet } from 'lodash/fp';

export const get = key => ldGet(`theme.${key}`);
export const modal = key => get(`modal.${key}`);
